import produce from "immer";

import {
  EARLY_VOTING_WATCH_ON,
  EARLY_VOTING_WATCH_OFF,
  AGENDA_ADD
} from "../actions/types";

const initialState = {
  dbSync: false
};

export default (state = initialState, action) => {
  return produce(state, draft => {
    // eslint-disable-next-line
    switch (action.type) {
      case EARLY_VOTING_WATCH_ON:
        draft = { dbSync: true, ...action.payload };
        return draft;
      case EARLY_VOTING_WATCH_OFF:
        draft = initialState;
        return draft;
      case AGENDA_ADD:
        // console.log("no need to update store");
        break;
    }
  });
};
